module.exports = __webpack_public_path__ + "3c89e6baa8d27c84fb612707e7a4dad6.svg";